export default __webpack_public_path__ + "static/media/thumb_7.be4c0c78.webp";